<template>
  <div>
    <vs-sidebar click-not-close parent="#email-app" :hidden-background="true"
                class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isSidebarActive"
                position-right>
      <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentMail">
        <div
            class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
          <div class="flex mb-4">
            <div class="flex items-center">
              <feather-icon :icon="'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"/>
              <h4 v-if="currentMail.subject">{{ currentMail.subject }}</h4>
              <h4 v-else>(no subject)</h4>
            </div>
          </div>
          <div class="ml-10 mb-4 mt-1">
            <div class="email__actions--single flex items-baseline">

              <!-- MOVE TO DROPDOWN -->
              <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" v-if="mailFilter !== sentFolderId">
                <feather-icon icon="FolderIcon" svg-classes="h-6 w-6" class="ml-4"/>
                <vs-dropdown-menu>
                  <vs-dropdown-item v-for="otherFolder in otherFolders" @click="moveTo(otherFolder.id)" v-if="mailFilter !== otherFolder.id" :key="otherFolder.id">
                    <span class="flex items-center" :style="otherFolder.style">
                      <feather-icon icon="FolderIcon" svgClasses="h-4 w-4" class="mr-2"/>
                      <span>{{ otherFolder.displayName }}</span>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <feather-icon icon="MailIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" @click="$emit('markUnread')"/>
              <feather-icon v-if="currentMail.mailFolder !== 'trash'" icon="TrashIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" @click="$emit('removeMail')"/>
              <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex"
                            @click="$emit('previousMail')"/>
              <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex"
                            @click="$emit('nextMail')"/>
            </div>
          </div>
        </div>

        <component :is="scrollbarTag" class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
          <div v-if="isSidebarActive">
            <!-- LATEST MESSAGE -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <email-mail-card :mailContent="currentMail"/>
              </div>
            </div>

            <div class="vx-row" style="margin-top: 2.2rem;">
              <div class="vx-col w-full">
                <vx-card>
                  <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                      <span class="text-lg">Click here to
                        <span class="text-primary font-semibold cursor-pointer" @click="$emit('showReply')">Reply</span>
                        or
                        <span class="text-primary font-semibold cursor-pointer" @click="$emit('showForward')">Forward</span>
                      </span>
                      <feather-icon icon="PaperclipIcon"/>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import EmailMailCard from './EmailMailCard.vue';
import FeatherIcon from "./components/FeatherIcon";
import VxCard from "./components/VxCard";

export default {
  props: {
    openMailId: {required: true, validator: prop => typeof prop === 'string' || prop === null},
    isSidebarActive: {type: Boolean, required: true},
    mailFilter: {type: String}
  },
  data() {
    return {
      showThread: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    EmailMailCard,
    FeatherIcon,
    VxCard
  },
  watch: {
    isSidebarActive(value) {
      if (!value) {
        this.$emit('closeSidebar');
        setTimeout(() => {
          this.showThread = false
        }, 500)
      }
    }
  },
  computed: {
    currentMail() {
      return this.$store.getters['email/getMail'](this.openMailId)
    },
    scrollbarTag() {
      return this.isTouchDevice() ? 'div' : 'VuePerfectScrollbar';
    },
    inboxFolderId() {
      return this.$store.state.email.inboxFolderId;
    },
    draftFolderId() {
      return this.$store.state.email.draftFolderId;
    },
    spamFolderId() {
      return this.$store.state.email.spamFolderId;
    },
    sentFolderId() {
      return this.$store.state.email.sentFolderId;
    },
    trashFolderId() {
      return this.$store.state.email.trashFolderId;
    },
    otherFolders() {
      return this.$store.state.email.mailFolders.others;
    }
  },
  methods: {
    moveTo(to) {
      this.$emit('closeSidebar');
      this.$emit('moveTo', to);
    },
    isTouchDevice() {
      const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
      const mq = function (query) {
        return window.matchMedia(query).matches
      };
      if ('ontouchstart' in window || window.DocumentTouch) {
        return true
      }
      const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
      return mq(query);
    },
  },
  updated() {
    if (!this.currentMail) return;
    if ((this.currentMail.isRead === false) && this.isSidebarActive && (!this.$store.state.email.mailUpdating)) {
      this.$store.dispatch('email/setUnread', {
        emailIds: [this.openMailId],
        unread: false
      }).then(() => {
        this.$store.dispatch('email/fetchMailFolders');
      });
    }
  }
}
</script>
